import React from 'react';
import * as styles from '../Card.style';

export type CardTitleProps = React.PropsWithChildren<{}>;

const CardTitle: React.FC<CardTitleProps> = ({
  children,
}) => (
  <div css={styles.title}>
    {children}
  </div>
);

export default CardTitle;
